import { emitConnectionsToolkitsChanged } from '@/events/connectionsEvents'
import { CONNECTED_TOOLKITS_SESSION_KEY } from './keys.js'

export function writeConnectedToolkits(slugs) {
  if (typeof sessionStorage === 'undefined') return
  const normalized = [...new Set(slugs.map((s) => String(s || '').toLowerCase().trim()).filter(Boolean))]
  sessionStorage.setItem(CONNECTED_TOOLKITS_SESSION_KEY, JSON.stringify(normalized))
}

export function dispatchConnectedToolkitsChanged() {
  emitConnectionsToolkitsChanged()
}

export function readConnectedToolkits() {
  if (typeof sessionStorage === 'undefined') return []
  try {
    const raw = sessionStorage.getItem(CONNECTED_TOOLKITS_SESSION_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.map((s) => String(s || '').toLowerCase().trim()).filter(Boolean)
  } catch {
    return []
  }
}

export function removeConnectedToolkitSlug(toolkitSlug) {
  const slug = String(toolkitSlug || '').trim().toLowerCase()
  if (!slug || typeof sessionStorage === 'undefined') return
  try {
    writeConnectedToolkits(readConnectedToolkits().filter((s) => s !== slug))
    dispatchConnectedToolkitsChanged()
  } catch {
    /* quota */
  }
}
